export const fileDownloadErrorSelector = state => state.fileDownload.error;
export const isFileDownloadPostingSelector = state => state.fileDownload.isPosting;
export const isFileDownloadChoiceSubmittedSelector = state => state.fileDownload.isSubmitted;
export const userFileDownloadChoiceSelector = state => state.fileDownload.userChoice;
